import { SAVED_VIDEO_STATE, MICRO_VOD_PLAN } from '@studio/constants/library';
import type { Shared } from '@studio/types';

const isAnyMediaSaveOnlyUpgradable = (items: Shared.Library.BaseMediaItem[], vodPlanId?: string | null): boolean => {
  return items.some(
    (media) =>
      (media.state === SAVED_VIDEO_STATE.SAVE_ONLY || media.state === SAVED_VIDEO_STATE.RESOLUTION_UPGRADE_PENDING) &&
      Boolean(vodPlanId) &&
      vodPlanId !== MICRO_VOD_PLAN
  );
};

export default isAnyMediaSaveOnlyUpgradable;
